import React from 'react';

function renderTransitionView () {
    if (typeof this.viewFunc === 'function') {
        return this.viewFunc(this);
    }
    return (<React.Fragment></React.Fragment>);
}

export default renderTransitionView;
